import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoadingStore = defineStore('loading', () => {
  const isLoading = ref(false)
  const loadingCount = ref(0)

  function startLoading() {
    loadingCount.value++
    isLoading.value = true
  }

  function stopLoading() {
    loadingCount.value = Math.max(0, loadingCount.value - 1)
    isLoading.value = loadingCount.value > 0
  }

  return {
    isLoading,
    startLoading,
    stopLoading
  }
})